import classes from '../create-schedule/CreateSchedule.module.scss';

interface DailyProps {
  dailyText: string;
}

export const DailyComp = (props: DailyProps) => {
  const { dailyText } = props;

  return (
    <div className={classes['day-align']} data-testid="dayText">
      {dailyText}
    </div>
  );
};
